module.exports = __webpack_public_path__ + "img/image00005-min.7e03069b.jpeg";